export const MOCK_ENDPOINTS = [
  // {
  //   name: 'AgreementId',
  //   url: '/sign',
  //   response: {
  //     agreementId: 'CBJCHBCAABAADBuGOvJA2IPhabIunGIlH_x-dV2wRD-y'
  //   },
  //   method: 'POST'
  // },
  // {
  //   name: 'Get sign documents',
  //   url: '/sign/CBJCHBCAABAADBuGOvJA2IPhabIunGIlH_x-dV2wRD-y',
  //   response: {
  //     signingUrl:
  //       'https://secure.na4.adobesign.com/public/apiesign?pid=CBFCIBAA3AAABLblqZhBaBT6mCAXDllI-d7nYHs0xpo48jPRlG32gehqIYd99HPl_utk2-dNH_mQVrFfeH0iABky7oq8r4Kp1YzscV9Y3&client_id=CBJCHBCAABAAQyvH2Z89kjAP2jsAs_h45QBktHUBrebB',
  //     documentNames: [
  //       'W8BEN.pdf',
  //       'CIPKYCPersonaNatural.pdf',
  //       'MoneyTransferAgreement.pdf',
  //       'CashManagementWithTokenForm.pdf'
  //     ],
  //     status: 'IN_PROCESS'
  //   },
  //   method: 'GET'
  // }
  // {
  //   name: 'Get Contract',
  //   url: '/ONB/contract/read/onboarding?contractId',
  //   response: {
  //     contractId: '1111111',
  //     documentByte: '155555',
  //     returnCode: '200',
  //     message: 'OK',
  //   },
  //   method: 'GET',
  // },
  // {
  //   name: 'New Holders',
  //   url: '/onboarding/1.0.0/agreement/new-2-holders',
  //   response: {
  //     validated: true,
  //     strOppId: 'string',
  //     status: '200',
  //     responseCode: '200',
  //     message: 'string',
  //     error: false,
  //   },
  //   method: 'POST',
  // },
  // {
  //   name: 'New Holders',
  //   url: '/onboarding/1.0.0/actionproxy',
  //   response: {
  //     validated: true,
  //     strRol: '',
  //     strOpportunityStage: '',
  //     // strOppId: '',
  //     strAccountType: '',
  //     strAccountNumber: '',
  //     status: '200',
  //     oppAcceptanceStatus: '',
  //     multiOwner: false,
  //     message: '',
  //     errorCode: '',
  //     error: false,
  //     holder: '',
  //     clsResponseSavePersonalData: {
  //       canModify: true,
  //       acceptanceStatus: '',
  //       dtBirhDate: '1990/01/01',
  //       dtExpeditionDate: '2023/31/12',
  //       strCountry: 'Colombia',
  //       strCountryISO: '170',
  //       strDocumentNumber: '21345676435',
  //       strDocumentType: 'Cédula',
  //       strDocumentTypeCode: 'CC',
  //       strEmail: 'test2@yopmail.com',
  //       strFirstLastName: 'Cardona',
  //       strFirstName: 'Jesús David',
  //       strGender: '',
  //       strMiddleName: 'Jesús',
  //       strNationality: '',
  //       strNationalityISO: '',
  //       strPhone: '6013819963',
  //       strSecondLastName: 'Alzate',
  //       integrationId: '',
  //       expeditionDocumentDepartment: 'Colombia',
  //     },
  //     clsResponseKYC: {
  //       strProfessionalSectorCode: '',
  //       strProfessionalSector: '',
  //       strOtherIncomeDetails: '',
  //       strOccupation: '',
  //       strOccupationCode: '',
  //       strCurrentPosition: '',
  //       strCurrentPositionCode: '',
  //       strActivityTypeCode: '',
  //       strActivityType: '',
  //       strAccountPurpose: '',
  //       numOtherIncome: 1,
  //       numMonthlyIncome: 1,
  //       numMonthlyExpenses: 1,
  //       numLiabilities: 1,
  //       numAssets: 1,
  //       blnHasAcceptFundsStatement: true,
  //     },
  //     clsResponseAddress: {
  //       strMunicipalityCode: '',
  //       strMunicipality: '',
  //       strDepartmentCode: '',
  //       strDepartment: '',
  //       strAddressComplement: '',
  //       strAddress: '',
  //     },
  //     clsConsents: {
  //       blnProductRegulations: true,
  //       blnPEPs: true,
  //       blnMobileBanking: true,
  //     },
  //     clsContract: {
  //       signingContractStatus: '',
  //       contractId: '11111111111',
  //     },
  //   },
  //   method: 'POST',
  // },
];
